import React from "react";
import "./css/LocationInfo.css";
import villageImg from "../Component/Images/gram.jpg";

const LocationInfo = () => {
  return (
    <section className="location-section">
      <div className="location-content">
        <h2>स्थान आणि भौगोलिक माहिती</h2>
        <p>
          <span className="highlight">तासगांव</span>  हे महाराष्ट्र राज्यातील सातारा जिल्ह्यातील कृष्णा नदीचा तिरावर वसलेलं एक सुंदर आणि विकसित गाव आहे. हे गाव सातारा तालुक्यात वसलेले असून, शांत वातावरण, मेहनती लोक आणि शेतीप्रधान तसेच सर्व जाती पाती एकत्र राहत असलेलं आणि उत्तम जीवनशैली यासाठी ओळखले जाते. गावामध्ये सुपीक जमीन, शेती आणि नैसर्गिक सौंदर्य आहे. तासगाव हे गाव सातारा तालुक्यातील एक मोठ्या लोकसंख्येचे गाव म्हणून ओळखले जाते तसेच हे गाव सातारा रहिमतपूर मार्गावरती साताऱ्यापासून 12 किमी अंतरावर आहे  त्यामुळे येथे पोहोचणे अतिशय सोपे आहे. गावात मूलभूत सुविधा, शिक्षण  संस्था, आरोग्य केंद्र आणि ग्रामविकासाच्या योजना सक्रिय आहेत.

        </p>
       
      </div>
      <div className="location-image">
        <img src={villageImg} alt="गावाचे दृश्य" />
      </div>
    </section>
  );
};

export default LocationInfo;
